import {
  HTTPQuery,
  ConvertShelfType,
  ConvertShelfTypeFromJSON,
  GetConvertShelfTypeRequest,
  GetConvertShelfTypeRequestToJSON,
  UpdateConvertShelfTypeRequest,
  UpdateConvertShelfTypeRequestToJSON
} from '@/api'
import * as runtime from '../runtime'

export class ConvertShelfTypeApi extends runtime.BaseAPI {
  /**
   * 配架区分変換情報を取得する
   * 配架区分変換情報取得
   */
  async getConvertShelfType(
    request: GetConvertShelfTypeRequest
  ): Promise<ConvertShelfType[]> {
    const queryParameters: runtime.HTTPQuery = Object.fromEntries(
      Object.entries(GetConvertShelfTypeRequestToJSON(request)).filter(
        value => value[1] !== undefined
      )
    ) as HTTPQuery
    const response = await this.requestGet(
      '/convert-shelf-types',
      queryParameters
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      jsonValue.map(ConvertShelfTypeFromJSON)
    ).value()
  }

  /**
   * 配架区分変換情報を更新する
   * 配架区分変換情報更新
   */
  async updateConvertShelfType(
    request: UpdateConvertShelfTypeRequest
  ): Promise<runtime.VoidApiResponse> {
    const bodyParameters: runtime.HTTPBody = UpdateConvertShelfTypeRequestToJSON(
      request
    )
    const response = await this.requestPost(
      '/convert-shelf-types',
      bodyParameters
    )

    return new runtime.VoidApiResponse(response)
  }
}
